'use strict';

var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var useDevelopmentEffect = require('../../_chunks/useDevelopmentEffect-DGG0KnB_.js');
var BaseButton = require('../../_chunks/BaseButton-DDcpn9-P.js');
require('@templafy/translation');
require('../../hooks/useCombinedRefs.js');
require('../../icons/IconLoading.js');
require('../../icons/Icon.js');
require('../../_chunks/combineClasses-5P8GTQkg.js');
require('../../_chunks/index-CIVOGJRG.js');
require('../../_chunks/designTokens-CKP-YoT2.js');
require('../../utilities/createComponentNamespace.js');

const Button = react.forwardRef(({ startIcon, endIcon, iconProps, children, ...props }, ref) => {
    useDevelopmentEffect.useDevelopmentEffect(() => {
        if (startIcon && endIcon) {
            console.error(`[Button] Start and end icons cannot be used at the same time. As both were set only the start icon will be rendered.`);
        }
    }, [startIcon, endIcon]);
    return (jsxRuntime.jsx(BaseButton.BaseButtonNamespace, { ...props, startAdornment: startIcon ? (jsxRuntime.jsx(BaseButton.BaseButtonNamespace.ButtonAdornmentIcon, { icon: startIcon, ...iconProps })) : undefined, endAdornment: !startIcon && endIcon ? (jsxRuntime.jsx(BaseButton.BaseButtonNamespace.ButtonAdornmentIcon, { icon: endIcon, ...iconProps })) : undefined, ref: ref, children: children }));
});
Button.displayName = 'Button';

exports.Button = Button;
//# sourceMappingURL=Button.js.map
